var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "flex h-13",
        on: {
          mouseover: function($event) {
            _vm.hoverState = true
          },
          mouseleave: function($event) {
            _vm.hoverState = false
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "sticky left-0 z-10 flex pl-6 bg-pure-white" },
          [
            _c(
              "div",
              {
                staticClass:
                  "flex items-center flex-shrink-0 w-20 px-4 transition-all duration-300 border-b border-l border-slate-400",
                class: [
                  _vm.isLast ? "rounded-bl" : "",
                  _vm.hoverState ? "bg-hover-state" : "bg-pure-white"
                ]
              },
              [
                _c("BlTextBody2", {
                  staticClass: "truncate text-slate-1000",
                  attrs: { text: _vm.credit.id }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex items-center flex-shrink-0 w-40 gap-2 px-4 transition-all duration-300 border-b border-r border-slate-400",
                class: [_vm.hoverState ? "bg-hover-state" : "bg-pure-white"]
              },
              [
                _c("BlTextBody2", {
                  staticClass: "truncate text-slate-1000",
                  attrs: { title: _vm.dateCreated, text: _vm.dateCreated }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex items-center flex-shrink-0 px-4 transition-all duration-300 border-b w-50 border-slate-400",
            class: [_vm.hoverState ? "bg-hover-state" : "bg-pure-white"]
          },
          [
            _c("BlTextBody2", {
              staticClass: "truncate",
              attrs: {
                title: _vm.credit.accountable_string,
                text: _vm.credit.accountable_string
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex items-center flex-shrink-0 px-4 transition-all duration-300 border-b w-35 border-slate-400",
            class: [_vm.hoverState ? "bg-hover-state" : "bg-pure-white"]
          },
          [_c("BlChip", { attrs: { chip: _vm.credit.type, dense: "" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex items-center flex-shrink-0 px-4 transition-all duration-300 border-b w-50 border-slate-400",
            class: [_vm.hoverState ? "bg-hover-state" : "bg-pure-white"]
          },
          [
            _c("BlTextBody2", {
              staticClass: "truncate",
              attrs: { title: _vm.serviceItem, text: _vm.serviceItem }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex items-center flex-shrink-0 px-4 transition-all duration-300 border-b w-35 border-slate-400",
            class: [_vm.hoverState ? "bg-hover-state" : "bg-pure-white"]
          },
          [_c("BlTextBody2", { attrs: { text: _vm.sessionCount } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex items-center flex-shrink-0 px-4 transition-all duration-300 border-b w-35 border-slate-400",
            class: [_vm.hoverState ? "bg-hover-state" : "bg-pure-white"]
          },
          [_c("BlTextBody2", { attrs: { text: _vm.rescheduleCount } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex items-center justify-between flex-shrink-0 px-4 transition-all duration-300 border-b w-50 border-slate-400",
            class: [_vm.hoverState ? "bg-hover-state" : "bg-pure-white"]
          },
          [
            _c("BlTextBody2", {
              attrs: { text: _vm.currentCenter.currency_sym }
            }),
            _vm._v(" "),
            _c("BlTextBody2", { attrs: { text: _vm.amount } })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex items-center flex-shrink-0 px-4 transition-all duration-300 border-b w-35 border-slate-400",
            class: [_vm.hoverState ? "bg-hover-state" : "bg-pure-white"]
          },
          [
            _c("BlTextBody2", {
              staticClass: "truncate",
              attrs: { title: _vm.expirationDate, text: _vm.expirationDate }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex items-center flex-grow flex-shrink-0 px-4 transition-all duration-300 border-b w-100 border-slate-400",
            class: [_vm.hoverState ? "bg-hover-state" : "bg-pure-white"]
          },
          [
            _c("BlTextBody2", {
              staticClass: "truncate whitespace-pre-line",
              attrs: { title: _vm.credit.reason, text: _vm.credit.reason }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sticky right-0 z-10 flex pr-6 bg-pure-white" },
          [
            _c(
              "div",
              {
                staticClass:
                  "flex items-center justify-center flex-shrink-0 transition-all duration-300 border-b border-r w-30 border-slate-400",
                class: [
                  _vm.isLast ? "rounded-br" : "",
                  _vm.hoverState ? "bg-hover-state" : "bg-pure-white"
                ]
              },
              [
                _vm.credit.appointment_id &&
                _vm.currentUser.role.includes("admin")
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          to:
                            "/appointments/details/" +
                            _vm.credit.appointment_id,
                          target: "_blank"
                        }
                      },
                      [
                        _c("BlInputButton", {
                          attrs: {
                            title: "View appointment details",
                            label: "View details",
                            type: "outlined",
                            dense: ""
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e674ce58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e674ce58","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/creditTransaction/Item.vue
// module id = null
// module chunks = 